import React from 'react';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './AccordionLocation.styles';

import AccordionMenu from '../accordionmenu/AccordionMenu';

const options = [
  {
    text: I18n.t('edit.edit'),
    value: 'edit'
  },
  {
    text: I18n.t('delete.delete'),
    value: 'delete'
  }
];

const AccordionLocation = props => {
  const handleLocationActions = action => {
    switch (action) {
      case 'delete':
        return props.delete(props.location);
      case 'edit':
        return props.onEdit(props.location);
      default:
        return;
    }
  };

  return (
    <div className={css(styles.base)}>
      <span className={css(styles.field)}>{props.location.name}</span>
      <span className={css(styles.field, styles.address)}>
        {props.location.macAddress || props.location.id}
      </span>
      <AccordionMenu
        styles={styles.options}
        options={options}
        handleClick={handleLocationActions}
      />
    </div>
  );
};

export default AccordionLocation;



// WEBPACK FOOTER //
// ./src/components/data/accordionlocation/AccordionLocation.js